import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
export const AppStoreLinks = ({ packageName, appStoreId, iosStatus, androidStatus, }) => {
    const androidLink = `https://play.google.com/store/apps/details?id=${packageName}`;
    const iosLink = `https://apps.apple.com/app/id${appStoreId}`;
    return (_jsxs(Box, Object.assign({ component: "div", sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
        } }, { children: [androidStatus === 'active' ? (_jsx("a", Object.assign({ href: androidLink, target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(Box, { component: "img", src: "/google-play-store-badge.webp", alt: "Get it on Google Play", width: "219", height: "65", sx: {
                        width: '219px',
                        height: '65px',
                        cursor: 'pointer',
                    } }) }))) : (_jsx(Tooltip, Object.assign({ title: "Coming Soon", "aria-describedby": "google-play-badge" }, { children: _jsx(Box, { component: "img", src: "/google-play-store-badge.webp", alt: "Coming Soon to Google Play", id: "google-play-badge", width: "219", height: "65", sx: {
                        width: '219px',
                        height: '65px',
                        opacity: 0.5,
                        cursor: 'not-allowed',
                    } }) }))), iosStatus === 'active' ? (_jsx("a", Object.assign({ href: iosLink, target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(Box, { component: "img", src: "/apple-app-store-badge.svg", alt: "Get it on the App Store", width: "193", height: "65", sx: {
                        width: '193px',
                        height: '65px',
                        cursor: 'pointer',
                    } }) }))) : (_jsx(Tooltip, Object.assign({ title: "Coming Soon", "aria-describedby": "app-store-badge" }, { children: _jsx(Box, { component: "img", src: "/apple-app-store-badge.svg", alt: "Coming Soon to the App Store", id: "app-store-badge", width: "193", height: "65", sx: {
                        width: '193px',
                        height: '65px',
                        opacity: 0.5,
                        cursor: 'not-allowed',
                    } }) })))] })));
};
